import React, { ReactElement } from 'react'
import { Button } from '@conekta/frontino-ui/Button'
import { IModalActionsContainer } from './interface'
import './styles.scss'

export const ModalActionsContainer = ({ buttons, className }: IModalActionsContainer): ReactElement => {
  return (
    <div className={`modal-actions ${className}`}>
      {buttons.map((button, key) => {
        return (
          <Button
            key={key}
            className={`modal-actions__${button.className}`}
            type={button.type}
            variant={button.variant}
            loading={button.loading}
            disabled={button.disabled}
            href={button.href}
            onClick={button.handleClick}
          >
            {button.text}
          </Button>
        )
      })}
    </div>
  )
}
